import React, { useState } from "react";
import Modal from "react-modal";
import i18next from "i18next";

import ita_img from "../../assets/icons/ita.svg";
import eng_img from "../../assets/icons/eng.svg";

const languages = [
    { code: "it-IT", label: "Italiano", caption: "Clicca per continuare in italiano", img: ita_img },
    { code: "en-EN", label: "English", caption: "Click to continue in English", img: eng_img },
];

const style = {
    overlay: {
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 10010,
    },
    content: {
        position: "absolute",
        left: "50%", top: "50%",
        transform: "translate(-50%, -50%)",
        width: "100%",
        maxWidth: "460px",
        border: "0",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "24px",
        outline: "none",
        padding: "0",
    },
};

export default function LanguageSelectModal({ show, onConfirm }) {
    const [selected, setSelected] = useState("it-IT");

    const handleConfirm = () => {
        i18next.changeLanguage(selected);
        onConfirm();
    };

    return (
        <Modal
            closeTimeoutMS={300}
            isOpen={show}
            contentLabel="language-select"
            className="center_modal"
            overlayClassName="bottom_modal_overlay"
            ariaHideApp={false}
            style={style}
        >
            <div style={{ padding: "32px 24px", textAlign: "center", color: "#212529" }}>
                <h2 style={{ marginBottom: "8px", color: "#212529" }}>Seleziona la lingua della piattaforma</h2>
                <p style={{ color: "#444", marginBottom: "4px" }}>Select the platform language</p>
                <p style={{ color: "#888", fontSize: "13px", marginBottom: "32px" }}>
                    La lingua dell'esame è indipendente da questa scelta.<br />
                    <em>The exam language is independent from this choice.</em>
                </p>
                <div className="d-flex justify-content-center gap-4" style={{ marginBottom: "32px" }}>
                    {languages.map((lang) => {
                        const isSelected = selected === lang.code;
                        return (
                            <button
                                key={lang.code}
                                onClick={() => setSelected(lang.code)}
                                style={{
                                    background: isSelected ? "#f0f6ff" : "none",
                                    border: `2px solid ${isSelected ? "#1a73e8" : "#ddd"}`,
                                    borderRadius: "12px",
                                    padding: "16px 24px",
                                    cursor: "pointer",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: "10px",
                                    transition: "border-color 0.2s, background 0.2s",
                                }}
                            >
                                <img src={lang.img} alt={lang.label} style={{ width: "48px", height: "48px" }} />
                                <span style={{ fontWeight: 600, fontSize: "16px", color: "#212529" }}>{lang.label}</span>
                                <span style={{ fontSize: "12px", color: "#888" }}>{lang.caption}</span>
                            </button>
                        );
                    })}
                </div>
                <button onClick={handleConfirm} className="mx-auto">
                    Conferma / Confirm
                </button>
            </div>
        </Modal>
    );
}
